/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BodyUploadVideoToGcsApiVideosUploadVideoGcsPost
 */
export interface BodyUploadVideoToGcsApiVideosUploadVideoGcsPost {
    /**
     * 
     * @type {string}
     * @memberof BodyUploadVideoToGcsApiVideosUploadVideoGcsPost
     */
    awemeId: string;
    /**
     * 
     * @type {string}
     * @memberof BodyUploadVideoToGcsApiVideosUploadVideoGcsPost
     */
    videoContent: string;
}

/**
 * Check if a given object implements the BodyUploadVideoToGcsApiVideosUploadVideoGcsPost interface.
 */
export function instanceOfBodyUploadVideoToGcsApiVideosUploadVideoGcsPost(value: object): value is BodyUploadVideoToGcsApiVideosUploadVideoGcsPost {
    if (!('awemeId' in value) || value['awemeId'] === undefined) return false;
    if (!('videoContent' in value) || value['videoContent'] === undefined) return false;
    return true;
}

export function BodyUploadVideoToGcsApiVideosUploadVideoGcsPostFromJSON(json: any): BodyUploadVideoToGcsApiVideosUploadVideoGcsPost {
    return BodyUploadVideoToGcsApiVideosUploadVideoGcsPostFromJSONTyped(json, false);
}

export function BodyUploadVideoToGcsApiVideosUploadVideoGcsPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyUploadVideoToGcsApiVideosUploadVideoGcsPost {
    if (json == null) {
        return json;
    }
    return {
        
        'awemeId': json['aweme_id'],
        'videoContent': json['video_content'],
    };
}

export function BodyUploadVideoToGcsApiVideosUploadVideoGcsPostToJSON(json: any): BodyUploadVideoToGcsApiVideosUploadVideoGcsPost {
    return BodyUploadVideoToGcsApiVideosUploadVideoGcsPostToJSONTyped(json, false);
}

export function BodyUploadVideoToGcsApiVideosUploadVideoGcsPostToJSONTyped(value?: BodyUploadVideoToGcsApiVideosUploadVideoGcsPost | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aweme_id': value['awemeId'],
        'video_content': value['videoContent'],
    };
}

